/**
 * Expose loader doesn’t map these to window.FLibs until we import them somewhere.
 * Until we figure out a better way, this file needs to be included on the charts page
 */
// eslint-disable-next-line react/no-typos
import 'classnames'
import { max, nice, scaleLinear, scaleSymlog } from 'd3'
import {
  add,
  addBusinessDays,
  differenceInCalendarDays,
  eachDayOfInterval,
  endOfDay,
  intervalToDuration,
  isSameMonth,
  isSameWeek,
  isWeekend,
  isWithinInterval,
  startOfDay,
  startOfYear,
  sub,
  subMonths,
  subYears,
} from 'date-fns'
import 'hammerjs'
// eslint-disable-next-line react/no-typos
import 'react'
import 'react-dom'
import { ErrorBoundary } from 'react-error-boundary'
import * as ReactRouterDOM from 'react-router-dom'

import { getFormattedDateString } from '../app/header/utils'
import { decodeQueryString, encodeQueryString } from '../app/queryString'
import { createAlertAsyncModule } from '../app/quote/create-alert/async-modules'
import { saveToPortfolioAsyncModule } from '../app/quote/save-to-portfolio/async-modules'
import logo from '../app/shared/assets/logo.png'
import logo_light from '../app/shared/assets/logo_light.png'
import { getHoverChartImg } from '../app/shared/hover-chart'
import { getSanitizedTicker } from '../app/shared/ticker-sanitizer'
import { formatDateToStringUS, getIsDrawingEnabledOnQuotePage } from '../app/shared/utils'
import './components/index'
import { portfolioWatchlistTableAsyncModule } from './components/portfolio/async-modules'
import { useSyncLocalStorage } from './hooks/use-sync-local-storage'
import { useTrackPageView } from './hooks/use-track-pageview'
import { useAsyncModule, withSuspense } from './services/async-modules-utils'
import { importWithRetry } from './services/import-with-retry'
import * as localStorage from './services/local-storage'

declare const FLibs: any

FLibs.saveToPortfolioAsyncModule = saveToPortfolioAsyncModule
FLibs.createAlertAsyncModule = createAlertAsyncModule
FLibs.ReactRouterDOM = ReactRouterDOM
FLibs.ReactErrorBoundary = { ErrorBoundary }
FLibs.getHoverChartImg = getHoverChartImg
FLibs.getSanitizedTicker = getSanitizedTicker
FLibs.decodeQueryString = decodeQueryString
FLibs.encodeQueryString = encodeQueryString
FLibs.getFormattedDateString = getFormattedDateString
FLibs.formatDateToStringUS = formatDateToStringUS
FLibs.useSyncLocalStorage = useSyncLocalStorage
FLibs.useTrackPageView = useTrackPageView
FLibs.getIsDrawingEnabledOnQuotePage = getIsDrawingEnabledOnQuotePage
FLibs.localStorage = localStorage
FLibs.portfolioWatchlistTableAsyncModule = portfolioWatchlistTableAsyncModule
FLibs.useAsyncModule = useAsyncModule
FLibs.withSuspense = withSuspense
FLibs.importWithRetry = importWithRetry
FLibs.d3 = { max, nice, scaleLinear, scaleSymlog }
FLibs.DateFns = {
  add,
  addBusinessDays,
  differenceInCalendarDays,
  eachDayOfInterval,
  endOfDay,
  intervalToDuration,
  isSameMonth,
  isSameWeek,
  isWeekend,
  isWithinInterval,
  startOfDay,
  startOfYear,
  sub,
  subMonths,
  subYears,
}
FLibs.assets = {
  logo,
  logo_light,
}
